export const ADDRESS_BOOK_ERROR_MESSAGE = {
  'Contact bulk limit exceeded':
    '연락처는 한 번에 최대 500개까지 추가할 수 있습니다. 엑셀의 연락처 개수를 확인해 주세요.',
  'Contact limit exceeded':
    '연락처는 최대 1,000개까지 추가할 수 있습니다. 등록된 연락처의 개수를 확인해 주세요.',
  'Contact not found': '연락처를 찾을 수 없습니다. 확인 후 다시 시도해 주세요.',
  'Forbidden Contact':
    '연락처를 이용할 수 없습니다. 접근 권한이 없거나 삭제된 연락처일 수 있습니다.',
};

export const EXCEL_DOWNLOAD_URL =
  'https://cdn.modusign.co.kr/service/address-book/%EC%A3%BC%EC%86%8C%EB%A1%9D_%EC%9D%BC%EA%B4%84%20%EB%93%B1%EB%A1%9D%20%EC%96%91%EC%8B%9D.xlsx';

export const MAX_CONTACT_COUNT = 1000;

export const ADDRESS_BOOK_HELP_URL = 'https://support.modusign.co.kr/100373486655';
